// extracted by mini-css-extract-plugin
module.exports = {"icon-button":"styles_icon-button__LgtgT"};